module.exports = __webpack_public_path__ + "static/img/ertongblue.7f51b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ertongblue.png
// module id = KHeu
// module chunks = 61